import { ICacheService } from '../iCacheService';
import { CommonUtils } from '@/util/commonUtils';
import { MedTransGoConstants } from '@/util/constants';
import { MemberProfile } from '@/types/response';

/**
 * @author <Aniket.P>
 * @description Cache service interface implementation
 * @copyright Supra International, inc
 */
export class LocalCacheService implements ICacheService {


    // persist value into local storage
    public saveValue(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    // get value from local storage
    public getValue(key: string): any {
        const value = localStorage.getItem(key);
        return value ? JSON.parse(value) : value;
    }

    // get user session info
    public getSessionInfo(): any {
        const jsonPayload = CommonUtils.parseJwt(this.getValue(MedTransGoConstants.FIELD_NAME_TOKEN));
        return jsonPayload;
    }

    public clearCache(): void {
        localStorage.clear();
        sessionStorage.clear();
    }

    // persist value into session storage
    public saveSessionValue(key: string, value: any): void {
        sessionStorage.setItem(key, JSON.stringify(value));
    }

    // get value from local storage
    public getSessionValue(key: string): any {
        const value = sessionStorage.getItem(key);
        return value ? JSON.parse(value) : value;
    }

    public getMemberInfo(): MemberProfile {
        return this.getValue(MedTransGoConstants.FIELD_MEMBER_PROFILE);
    }

    // remove session value
    public removeSessionValue(key: string): void {
        sessionStorage.removeItem(key);
    }
}
